'use client';

import { i18n } from '@/i18n/i18n.config';
import { usePathname, useSearchParams } from 'next/navigation';

const delay = 600;

export enum EventClickType {
    pageView = 'pageview',
    clickBanner = 'click_banner',
    clickCtaButton = 'click_cta_button',
    clickHeaderMenu = 'click_header_menu',
}

export type TrackerOptions = {
    eventType?: EventClickType;
    url?: string;
    internal_ad?: string;
    _pageId?: string;
};

const getWCIPCuno = () => {
    return (window as any)?.WCIPCookie?.getCuno && (window as any)?.WCIPCookie?.getCuno() || '';
  }
  const getWCIPCustomerSegment = () => {
    return (window as any)?.WCIPCookie?.getCustomerSegment && (window as any)?.WCIPCookie?.getCustomerSegment() || '';
  }

function removeProtocolFromUrl(url: string) {
    if (!url) return;
    return url.replace(/^https?:\/\//, '');
}

const getClickEventInternalAd = (urlString: string) => {
    const originPath = window.location.origin || '';
    const url = new URL(urlString, originPath);
    const params = new URLSearchParams(url.search);
    const b_cid = params.get('b_cid');
    return b_cid;
};

const useALTracker = () => {
    const searchParams = useSearchParams();
    const pathname = usePathname();
    const currentLang = i18n.locales.find((i) => {
        const Reg = new RegExp(i);
        return pathname.match(Reg);
    });

    const language = currentLang === 'en-US' ? 'en' : currentLang?.toLocaleLowerCase();

    const ALTrackClickEvent = (eventID: string, options?: TrackerOptions) => {        
        return new Promise(async (resolve) => {
            const adobeDataLayer = (window as any).adobeDataLayer;
            if (adobeDataLayer) {
                const pushData = Object.assign({
                    event: options?.eventType || EventClickType.clickCtaButton,
                    interaction: {
                        eventID: eventID || '',
                    },
                    // @ts-ignore
                    internal_ad: options?.internal_ad ? options?.internal_ad : options?.url ? getClickEventInternalAd(options?.url) : '',
                    //Page Info Optional
                    page: {
                        name: removeProtocolFromUrl(window?.location?.origin + window?.location?.pathname),
                        id: options?._pageId || '',
                        language,
                    },
                    user: {
                        cuno: getWCIPCuno(),
                        customer_segment: getWCIPCustomerSegment(),
                        tagged_member: '',
                        targeted_member: '',
                    },
                });

                adobeDataLayer.push(pushData);
                setTimeout(() => {
                    resolve(true);
                }, delay);
            } else {
                resolve(false);
                if (!eventID) {
                    return;
                }
            }
        });
    };

    const ALTrackPageLoad = async (_pageId: string) => {
        const adobeDataLayer = (window as any)?.adobeDataLayer;
        // @ts-ignore
        const isEU = window?.WAGdpr?.isEU();
        if (adobeDataLayer && isEU !== undefined) {
            if (adobeDataLayer[0]?.event !== 'watracking') {
                adobeDataLayer.push({
                    event: 'watracking',
                    IsEU: false,
                    // "IsEU": isEU
                });
            }
            const _pushData = {
                event: EventClickType.pageView,
                page: {
                    name: removeProtocolFromUrl(window?.location?.origin + window?.location?.pathname), //Optional
                    id: _pageId,
                    language,
                },
                internal_ad: searchParams?.get('b_cid') || '',
                user: {
                    cuno: getWCIPCuno(),
                    customer_segment: getWCIPCustomerSegment(),
                    tagged_member: '',
                    targeted_member: '',
                },
            };
            adobeDataLayer.push(_pushData);
            // console.log('pageLoad _pushData', _pushData)
        } else {
            setTimeout(() => {
                ALTrackPageLoad(_pageId);
            }, 2000);
            // console.log('adobeDataLayer is undefined.');
        }
    };

    return {
        ALTrackPageLoad,
        ALTrackClickEvent,
    };
};

export default useALTracker;
